import { createSlice } from "@reduxjs/toolkit";

const showLogModalSlice = createSlice({
  name: "showLogModal",
  initialState: true,
  reducers: {
    showModal(state, action) {
      return true;
    },
    hideModal(state, action) {
      return false;
    },
  },
});

export const { showModal, hideModal } = showLogModalSlice.actions;

export default showLogModalSlice.reducer;
